function Card(props) {
  const { extra, children, ...rest } = props;
  return (
    <div
      className={`relative flex flex-col rounded-[20px] bg-white border border-gray-100 shadow-sm ${extra}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default Card;